import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import 'rxjs/add/operator/map';
import {Config} from '../config';

@Injectable()
export class BarAndRestaurantService {

  public backendUrl: any = new Config();

  constructor(private http: Http) { }

  getBar() {
    return this.http.get(this.backendUrl.backendUrl + 'bars/getAll').map(res => res.json());
  }

  getRestaurant() {
    return this.http.get(this.backendUrl.backendUrl + 'restaurants/getAll').map(res => res.json());
  }

}



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/services/bar-and-restaurant.service.ts